import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function DropBtn(props) {
  // const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    // setAge(event.target.value);
    props.onChange(event.target.value);
  };
  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth id={`${props.noEvent ? "static-option" : ""}${props.title.includes("Select the scholarship program") && "source-type"}`}>
        <InputLabel id="demo-simple-select-label">{props.title}</InputLabel>
        <Select
          labelId="demo-simple-select-label "
          id={`demo-simple-select ${props.title.includes("Select the scholarship program") && "source-type"}`}
          value={props?.value}
          label="props.title"
          onChange={handleChange}
          // getOptionDisabled={(option) =>
          //   option?.active === false
          // }
        >
          {props.list?.map((item, index) => {
            return (
              <MenuItem key={index} value={item} className={`${item?.programType && !item?.active && "disabled"}  `}>
                {/* {item} */}
                {props.title?.includes("Select the scholarship program")? item?.programType && !item?.active ? `${item?.programType} (No longer accepting applications)`:item?.programType ?? "": item}
              </MenuItem>
            );
          })}
          {/*           
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem> */}
        </Select>
      </FormControl>
    </Box>
  );
}

// import React, { useEffect, useState } from "react";

// const Dropdown = (props) => {
//   const [selectedGender, setSelectedGender] = useState("");
//   const [list, setList] = useState([]);

//   const handleGenderChange = (event) => {
//     setSelectedGender(event.target.value);
//   };
//   useEffect(() => {
//     let newList = [];
//     if (props.type === "gender") {
//       newList = ["Male", "Female", "Other"];
//     } else if (props.type === "master") {
//       newList = ["MBA", "PGDM", "MMS"];
//     } else {
//       newList = [
//         "Self Employed",
//         "Daily Wage Earner ",
//         "Govt. Services",
//         "Defense Services",
//         "Private Sector employee",
//         "Non-Govt. Services",
//         "Business",
//         "Unemployed",
//         "Other",
//       ];
//     }

//     setList([...newList]);
//   }, []);
//   return (
//     <div className="drop-div">
//       {/* <label htmlFor="gender">Select Gender:</label> */}
//       <select
//         // id="gender"
//         value={selectedGender}
//         style={{
//           width: "84%",
//           height: "33px",
//           border: "none",
//           outline: "none",
//           boxShadow: "none",
//           fontSize: "18px",
//           color: "#0000004d",
//         }}
//         onChange={handleGenderChange}
//       >
//         {/* <option value="">Select</option> */}
//         {list.map((item, index) => {
//           return (
//             <option key={index} value={item}>
//               {item}
//             </option>
//           );
//         })}
//         ,
//       </select>

//       {/* {selectedGender && <p>Selected Gender: {selectedGender}</p>} */}
//     </div>
//   );
// };

// export default Dropdown;
